/* eslint-disable */
function createLoadJS() {
  const cache = {}
  const head = document.getElementsByTagName('head')[0] || document.documentElement

  function exec(options) {
    if (typeof options === 'string') {
      options = {
        url: options,
      }
    }

    const cacheId = options.id || options.url
    const cacheEntry = options.useCache === false ? false : cache[cacheId]

    if (cacheEntry) {
      console.log('injectScript: cache hit', cacheId)
      return cacheEntry
    } else if (options.allowExternal !== false) {
      const el = getScriptById(options.id) || getScriptByUrl(options.url)

      if (el) {
        const promise = Promise.resolve(el)

        if (cacheId) {
          cache[cacheId] = promise
        }

        return promise
      }
    }

    if (!options.url && !options.text) {
      throw new Error('injectScript: must provide a url or text to load')
    }

    const pending = (options.url ? loadScript : runScript)(head, createScript(options))

    if (cacheId && options.cache !== false) {
      cache[cacheId] = pending
    }

    return pending
  }

  function runScript(head, script) {
    head.appendChild(script)
    return Promise.resolve(script)
  }

  function loadScript(head, script) {
    return new Promise(((resolve, reject) => {
      // Handle Script loading
      let done = false

      // Attach handlers for all browsers.
      //
      // References:
      // http://stackoverflow.com/questions/4845762/onload-handler-for-script-tag-in-internet-explorer
      // http://stevesouders.com/efws/script-onload.php
      // https://www.html5rocks.com/en/tutorials/speed/script-loading/
      //
      script.onload = script.onreadystatechange = function () {
        if (!done && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
          done = true

          // Handle memory leak in IE
          script.onload = script.onreadystatechange = null
          resolve(script)
        }
      }

      script.onerror = reject

      head.appendChild(script)
    }))
  }

  function createScript(options) {
    const script = document.createElement('script')
    script.charset = options.charset || 'utf-8'
    script.type = options.type || 'text/javascript'
    script.async = !!options.async
    script.id = options.id || options.url
    script.loadJS = 'watermark'

    if (options.url) {
      script.src = options.url
    }

    if (options.text) {
      script.text = options.text
    }

    return script
  }

  function getScriptById(id) { // eslint-disable-line
    const script = id && document.getElementById(id)

    if (script && script.loadJS !== 'watermark') {
      console.warn('injectScript: duplicate script with id:', id)
      return script
    }
  }

  function getScriptByUrl(url) { // eslint-disable-line
    const script = url && document.querySelector(`script[src='${url}']`)

    if (script && script.loadJS !== 'watermark') {
      console.warn('injectScript: duplicate script with url:', url)
      return script
    }
  }

  return function load(items) {
    return items instanceof Array ?
      Promise.all(items.map(exec)) :
      exec(items)
  }
}

export const injectScript = createLoadJS()



// WEBPACK FOOTER //
// ./src/utils/injectScript.js